import { render, staticRenderFns } from "./Inboundlist-center.vue?vue&type=template&id=38bed406&scoped=true&"
import script from "./Inboundlist-center.vue?vue&type=script&lang=js&"
export * from "./Inboundlist-center.vue?vue&type=script&lang=js&"
import style0 from "./Inboundlist-center.vue?vue&type=style&index=0&id=38bed406&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bed406",
  null
  
)

export default component.exports